import { Center, AuthorInfo } from './author.styled';
import CheckMark from '@assets/icons/CheckMark';
import { Paragraph } from '@components/core/paragraph/Paragraph';
import Flag from '@assets/images/american-flag-fallback.svg';
import AuthorImage from '@assets/images/author-fallback.png';
import { useIsMobile } from '@hooks/useIsMobile';

interface AuthorProps {
	authorImage?: string;
	flagImage?: string;
	lastUpdated?: string;
	writtenBy?: string;
	advertisingDisclosure?: string;
	advertisingDisclosureLink?: string;
	dataDaysAgo: number;
	authorName?: string;
}

const Author: React.FC<AuthorProps> = ({
	authorImage,
	flagImage,
	lastUpdated = '',
	writtenBy = '',
	advertisingDisclosure = '',
	advertisingDisclosureLink = '',
	dataDaysAgo,
	authorName,
}) => {
	const isMobile = useIsMobile(768);

	return (
		<AuthorInfo>
			<CheckMark />
			<Paragraph $variant="regular" $color="#DFDFDF">
				{lastUpdated} <span data-days-ago={dataDaysAgo}></span> |{' '}
				<a style={{ fontWeight: 'normal', textDecoration: 'none' }} href={advertisingDisclosureLink}>
					{advertisingDisclosure}
				</a>
				{!isMobile && ' |'}
			</Paragraph>
			<Paragraph $variant="regular" $color="#DFDFDF">
				<Center>
					<img src={authorImage || AuthorImage} style={{ width: '16px', height: 'auto' }} alt="Author" />
					&nbsp; {writtenBy} {authorName} &nbsp;
					<img src={flagImage || Flag} alt="Flag" style={{ height: '14px', width: 'auto' }} />
				</Center>
			</Paragraph>
		</AuthorInfo>
	);
};

export default Author;
